module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 打开手机微信扫码登录 ")]), _vm._v(" "), _c('div', {
    staticClass: "wx-box m-b-20"
  }, [_c('wechartQR', {
    attrs: {
      "id": "login_container",
      "redirect-path": "/wxlogin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("使用账号登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53644932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/wechatLogin.vue
// module id = 878
// module chunks = 1